import { Image, Text, View } from "@react-pdf/renderer";
import { NumberFormatTextPDF } from "../NumberFormatText";
import { tableRowStyles } from "./SmartTitanProjektPDF";

export function DataRow({ item }) {
  let itemIndex = item.itemIndex;

  return (
    <View style={tableRowStyles.row} key={(itemIndex++).toString()}>
      {/* Title */}
      {item?.title ? (
        <Text style={tableRowStyles.title}>{item.title}</Text>
      ) : (
        <Text style={tableRowStyles.title}></Text>
      )}

      {/* Bezeichnungsbild */}
      {item?.bezImage ? (
        <View style={tableRowStyles.bezimage}>
          <Image
            src={{
              uri: item.bezImage.uri,
              method: "GET",
              headers: {},
            }}
            style={{
              height: item.bezImage.height,
              width: item.bezImage.width,
            }}
          />
        </View>
      ) : (
        <Text style={tableRowStyles.bezimage} />
      )}

      {/* Value */}
      <Text style={tableRowStyles.value}>
        <NumberFormatTextPDF value={item?.value} decimalScale={item.valueScale} />
      </Text>

      {/* Unit */}
      {item.valueUnit ? (
        <Text style={tableRowStyles.unit}>{item?.valueUnit}</Text>
      ) : item.unitImage ? (
        <View style={tableRowStyles.unit}>
          <Image
            src={{
              uri: item.unitImage.uri,
              method: "GET",
              headers: {},
            }}
            style={{
              height: item.unitImage.height,
              width: item.unitImage.width,
            }}
          />
        </View>
      ) : item.unitComponent ? (
        item.unitComponent
      ) : (
        <Text style={tableRowStyles.unit}></Text>
      )}

      {/* Formula */}
      {item?.formulaImage ? (
        <View style={tableRowStyles.formula}>
          <Image
            src={{
              uri: item.formulaImage.uri,
              method: "GET",
              headers: {},
            }}
            style={{
              height: item.formulaImage.height,
              width: item.formulaImage.width,
            }}
          />
        </View>
      ) : (
        <Text style={tableRowStyles.formula}>{item?.formulaText && item.formulaText}</Text>
      )}
    </View>
  );
}

export function DataRowTextValue({ item }) {
  let itemIndex = item.itemIndex;
  return (
    <View style={tableRowStyles.row} key={(itemIndex++).toString()}>
      {/* Title */}
      <Text style={tableRowStyles.title}>{item.title}</Text>

      {/* Bezeichnungsbild */}
      {item.bezImage ? (
        <View style={tableRowStyles.bezimage}>
          <Image
            src={{
              uri: item.bezImage.uri,
              method: "GET",
              headers: {},
            }}
            style={{
              height: item.bezImage.height,
              width: item.bezImage.width,
            }}
          />
        </View>
      ) : (
        <Text style={tableRowStyles.bezimage}> </Text>
      )}

      {/* Value */}
      <Text style={tableRowStyles.value}>{item?.value}</Text>

      {/* Unit */}
      <Text style={tableRowStyles.unit}>{item?.valueUnit}</Text>

      {/* Formula */}
      {item?.formulaImage ? (
        <View style={tableRowStyles.formula}>
          <Image
            src={{
              uri: item.formulaImage.uri,
              method: "GET",
              headers: {},
            }}
            style={{
              height: item.formulaImage.height,
              width: item.formulaImage.width,
            }}
          />
        </View>
      ) : (
        <Text style={tableRowStyles.formula}></Text>
      )}
    </View>
  );
}

export function DataRowText({ item }) {
  let itemIndex = item.itemIndex;
  return (
    <View style={tableRowStyles.rowInfoText} key={(itemIndex++).toString()}>
      {/* Title */}
      <Text style={tableRowStyles.textTitle}>{item.title}</Text>
    </View>
  );
}

export function DataRowThreeText({ item }) {
  let itemIndex = item.itemIndex;
  return (
    <View style={tableRowStyles.rowInfoText} key={(itemIndex++).toString()}>
      <Text style={tableRowStyles.treewayvalue_one}>
        <NumberFormatTextPDF value={item?.value_one} decimalScale={item.valueScale} />
      </Text>
      <View style={tableRowStyles.treewayvalue_sign}>
        <Image
          src={{
            uri: item.signImage.uri,
            method: "GET",
            headers: {},
          }}
          style={{
            height: item.signImage.height,
            width: item.signImage.width,
          }}
        />
      </View>
      <Text style={tableRowStyles.treewayvalue_two}>
        <NumberFormatTextPDF value={item?.value_two} decimalScale={item.valueScale} />
      </Text>
      <Text style={tableRowStyles.treewayvalue_unit}>{item.unit}</Text>
    </View>
  );
}

export function DataRowThreeImage({ item }) {
  let itemIndex = item.itemIndex;
  return (
    <View style={tableRowStyles.rowInfoText} key={(itemIndex++).toString()}>
      <View style={tableRowStyles.treewayvalue_one_image}>
        <Image
          src={{
            uri: item.value1Image.uri,
            method: "GET",
            headers: {},
          }}
          style={{
            height: item.value1Image.height,
            width: item.value1Image.width,
          }}
        />
      </View>
      <View style={tableRowStyles.treewayvalue_sign}>
        <Image
          src={{
            uri: item.signImage.uri,
            method: "GET",
            headers: {},
          }}
          style={{
            height: item.signImage.height,
            width: item.signImage.width,
          }}
        />
      </View>
      <View style={tableRowStyles.treewayvalue_two_image}>
        <Image
          src={{
            uri: item.value2Image.uri,
            method: "GET",
            headers: {},
          }}
          style={{
            height: item.value2Image.height,
            width: item.value2Image.width,
          }}
        />
      </View>
      <Text style={tableRowStyles.treewayvalue_unit}>{item.unit}</Text>
    </View>
  );
}
